import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021139';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-brand-light">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-stone-500 text-base font-bold hover:text-brand-gold transition-colors mb-12"
        >
          <span className="text-xl">←</span> Return to main page
        </Link>

        <div className="mb-14 border-b border-stone-200 pb-10">
          <p className="text-brand-gold text-sm uppercase tracking-widest font-bold mb-4">Legal</p>
          <h1 className="text-5xl font-serif text-brand-dark mb-4">Privacy Policy</h1>
          <p className="text-stone-500 text-base font-medium">
            Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>

        <div className="space-y-12">
          <Section title="1. Who We Are">
            <p>
              This privacy policy applies to the advisory practice of Acharyaji Ajay L Agarwal. We offer Vedic Astrology and Vastu Shastra consultations globally.
            </p>
            <p>
              For any privacy-related questions, contact us via Topmate at: {TOPMATE_URL}
            </p>
          </Section>

          <Section title="2. Information We Collect">
            <p>We collect information necessary to provide our advisory services:</p>
            <ul>
              <li>Name and email address (provided during booking)</li>
              <li>Date of birth, time of birth, and birth location (required for astrological charts)</li>
              <li>Information voluntarily shared during consultations</li>
            </ul>
            <p>
              We do not collect payment details directly. Payments are processed securely via Topmate.
            </p>
          </Section>

          <Section title="3. How We Use Your Information">
            <p>Your information is used exclusively to:</p>
            <ul>
              <li>Prepare your astrological birth chart prior to consultation</li>
              <li>Conduct the consultation session</li>
              <li>Send follow-up materials discussed during the session</li>
              <li>Respond to direct inquiries</li>
            </ul>
          </Section>

          <Section title="4. Data Sharing">
            <p>
              We do not sell or share your personal information for commercial purposes. Information is shared only with:
            </p>
            <ul>
              <li>Topmate (booking platform) for appointment processing</li>
              <li>Video conferencing tools (Zoom/Google Meet) for conducting sessions</li>
              <li>Where required by applicable law</li>
            </ul>
          </Section>

          <Section title="5. Data Retention">
            <p>
              We retain consultation notes and chart data up to 3 years to maintain advisory continuity. You may request deletion at any time via Topmate.
            </p>
          </Section>

          <Section title="6. Security">
            <p>
              We take reasonable precautions to protect your personal information. Sessions are conducted over standard encrypted platforms.
            </p>
          </Section>
        </div>

        <div className="mt-20 pt-10 border-t border-stone-200">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-10 py-5 bg-brand-dark text-white hover:bg-brand-gold transition-all duration-300 rounded-sm font-bold tracking-wide text-lg"
          >
            Return to Main Page
          </Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-2xl font-serif text-brand-dark mb-5">{title}</h2>
      <div className="space-y-4 text-stone-600 font-medium text-lg leading-relaxed [&_ul]:space-y-3 [&_ul]:pl-5 [&_ul]:list-none [&_ul_li]:flex [&_ul_li]:gap-3 [&_ul_li]:before:content-['·'] [&_ul_li]:before:text-brand-gold [&_ul_li]:before:text-2xl [&_ul_li]:before:leading-none [&_ul_li]:before:flex-shrink-0">
        {children}
      </div>
    </div>
  );
}